import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiClient } from "@/lib/auth";
import { Sparkles, ArrowRight } from "lucide-react";

export default function UsageMeter() {
  const [u, setU] = useState(null);
  useEffect(() => { apiClient.get("/usage").then(r => setU(r.data)).catch(()=>{}); }, []);
  if (!u || u.plan !== "free") return null;
  const { used, limit } = u.content;
  const remaining = Math.max(0, limit - used);
  const pct = Math.min(100, Math.round((used / Math.max(1, limit)) * 100));
  const danger = remaining <= 1;

  return (
    <div className="border border-border rounded-2xl p-5 bg-gradient-to-br from-primary/5 to-violet-500/5 relative overflow-hidden" data-testid="usage-meter">
      <div className="flex items-center justify-between mb-3">
        <div>
          <p className="text-[10px] uppercase tracking-[0.25em] font-bold text-muted-foreground">Plan Free</p>
          <p className="text-sm font-semibold mt-0.5">
            {remaining > 0
              ? <>Il vous reste <span className={danger ? "text-rose-500" : "text-primary"}>{remaining} contenu{remaining > 1 ? "s" : ""}</span> ce mois</>
              : <span className="text-rose-500">Vous avez utilisé vos 3 contenus du mois</span>}
          </p>
        </div>
        <div className="text-right">
          <div className="text-2xl font-black font-display tabular-nums">{used}<span className="text-muted-foreground text-sm">/{limit}</span></div>
        </div>
      </div>
      <div className="h-1.5 bg-muted rounded-full overflow-hidden mb-3">
        <div className={`h-full rounded-full transition-all duration-700 ${danger ? "bg-rose-500" : "bg-gradient-to-r from-primary to-violet-500"}`} style={{ width: `${pct}%` }} />
      </div>
      <Link to="/dashboard/pricing">
        <button className="w-full text-sm font-semibold inline-flex items-center justify-center gap-1.5 px-3 py-2 rounded-full bg-gradient-to-r from-primary to-violet-500 text-white hover:opacity-90 transition-opacity" data-testid="usage-upgrade-btn">
          <Sparkles className="h-3.5 w-3.5" />Passer Pro · contenus illimités<ArrowRight className="h-3.5 w-3.5" />
        </button>
      </Link>
    </div>
  );
}
